import { render } from "./AccountMenu.vue?vue&type=template&id=38f2758c"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/sufoservices/public_html/admin.sufoservices.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__